
// src/config.ts
// BACKEND_URL is injected at build time via Webpack DefinePlugin.
// For dev with webpack-dev-server proxy, we can call relative paths
// by leaving BACKEND_URL empty. apiUrl() handles both cases.

declare const __BACKEND_URL__: string | undefined;
declare const __DEV_TOOLS__: string | undefined;

export const BACKEND_URL: string =
  typeof __BACKEND_URL__ !== "undefined" && __BACKEND_URL__ ? __BACKEND_URL__ : "";

export const DEV_TOOLS: boolean = (() => {
  const raw = typeof __DEV_TOOLS__ !== "undefined" ? __DEV_TOOLS__ : "";
  return raw === "1" || raw === "true";
})();

/** Build an absolute URL when BACKEND_URL is set, otherwise return a relative path (for dev proxy). */
export function apiUrl(path: string): string {
  const base = (BACKEND_URL || "").trim();
  return base ? `${base}${path}` : path;
}
